import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/app/src/app/(citizen)/votacao/_components/banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopicsListItem"] */ "/app/src/app/(citizen)/votacao/_components/theme/theme-buttons/topics-list-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InteractionTabs"] */ "/app/src/app/(citizen)/votacao/(interactions)/_components/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollButton"] */ "/app/src/components/footer/scroll-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/header/user-menu/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/icons/chat-solid.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/chat.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/like-solid.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/like.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/share-rectangle.svg");
